import { Fragment } from 'react'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './TopBar.module.scss'
import { ChevronRightSmall } from 'blaze-ui/icons'
import { useOnboardingStrategiesEnabled } from 'flows/virtualMarketerOnboarding/steps'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type LegacyStep = 'yourBusiness' | 'goalsAndPlan' | 'yourBrand' | 'generateContent'
type V4Step = 'gettingStarted' | 'strategy' | 'campaign' | 'content' | 'finishingUp'

interface Props {
  highlightStep: LegacyStep | V4Step
  leftSide?: boolean
  withScoreCard?: boolean
}

const V4_STEPS: { key: V4Step; label: string }[] = [
  { key: 'gettingStarted', label: 'Getting started' },
  { key: 'strategy', label: 'Strategy' },
  { key: 'campaign', label: 'Campaign' },
  { key: 'content', label: 'Content' },
  { key: 'finishingUp', label: 'Finishing up' },
]

const LEGACY_STEPS: { key: LegacyStep; label: string }[] = [
  { key: 'yourBusiness', label: 'Your Business' },
  { key: 'goalsAndPlan', label: 'Goals & Plan' },
  { key: 'yourBrand', label: 'Your Brand' },
  { key: 'generateContent', label: 'Generate Content' },
]

const V4_STEP_KEYS = new Set<string>(V4_STEPS.map((s) => s.key))

export const TopBar = ({ highlightStep, leftSide = false, withScoreCard = false }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const isOnboardingStrategiesEnabled = useOnboardingStrategiesEnabled()

  if (!isOnboardingStrategiesEnabled || isMobile) return null

  const steps = V4_STEP_KEYS.has(highlightStep) ? V4_STEPS : LEGACY_STEPS

  return (
    <div className={cx(Styles.container, { [Styles.leftSide]: leftSide, [Styles.withScoreCard]: withScoreCard })}>
      {steps.map((step, index) => (
        <Fragment key={step.key}>
          {index > 0 && <ChevronRightSmall size={12} color="var(--dark-40)" />}
          <Text variant="placeholder" color={highlightStep === step.key ? 'var(--dark-90)' : 'var(--dark-40)'}>
            {step.label}
          </Text>
        </Fragment>
      ))}
    </div>
  )
}
